var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { nanoid } from "nanoid";
import Label from "../Label";
import Switch from "../Switch";
import style from "./style.module.scss";
export default function StyledSwitch(props) {
    const { id, name, value, label, description, boldLabel = false } = props, inputProps = __rest(props, ["id", "name", "value", "label", "description", "boldLabel"]);
    const switchID = id || nanoid(10);
    const descriptionID = nanoid(10);
    return (_jsxs("div", { className: style["styled-switch"], children: [_jsx(Switch, Object.assign({}, inputProps, { id: switchID, "aria-describedby": descriptionID, name: name, value: value })), _jsxs("div", { className: style["styled-switch__details"], children: [label ? (_jsx(Label, { htmlFor: switchID, className: classNames(style["styled-switch__details__label"], {
                            [style["styled-switch__details__label--bold"]]: boldLabel,
                        }), children: label })) : null, description ? (_jsx("div", { className: style["styled-switch__details__description"], id: descriptionID, children: description })) : null] })] }));
}
